<script setup lang="ts">
import { reactive, ref } from "vue";
import { useRouter } from "vue-router";
import { api } from "../api";

const router = useRouter();
const form = reactive({ currentPassword: "", newPassword: "", confirmPassword: "" });
const loading = ref(false);
const error = ref("");

async function submit() {
  error.value = "";
  if (form.newPassword !== form.confirmPassword) { error.value = "两次输入的新密码不一致"; return; }
  loading.value = true;
  try {
    await api.changePassword(form.currentPassword, form.newPassword);
    await router.replace("/");
  } catch (e) { error.value = (e as Error).message; }
  finally { loading.value = false; }
}
</script>

<template><div class="login-page"><section class="login-story"><span class="eyebrow">FIRST LOGIN</span><h1>设置只属于工作台的新密码</h1><p>统一登录不等于多个系统共用一个密码。初始密码只能使用一次，修改后再进入工作台。</p></section><section class="login-panel"><div class="login-card"><h2>修改初始密码</h2><p class="muted">至少 12 位，并包含大小写字母、数字和特殊字符。</p><el-alert v-if="error" :title="error" type="error" :closable="false" show-icon style="margin:20px 0"/><el-form label-position="top"><el-form-item label="当前密码"><el-input v-model="form.currentPassword" type="password" show-password/></el-form-item><el-form-item label="新密码"><el-input v-model="form.newPassword" type="password" show-password/></el-form-item><el-form-item label="确认新密码"><el-input v-model="form.confirmPassword" type="password" show-password @keyup.enter="submit"/></el-form-item><el-button type="primary" :loading="loading" @click="submit">保存并进入工作台</el-button></el-form></div></section></div></template>
